import { createFileRoute } from "@tanstack/react-router";
import { MachinesPage } from "@/features/settings/machines-page";

export const Route = createFileRoute("/_app/settings/machines")({ component: MachinesPage });
